import React, { useEffect, useState } from 'react';

import { DataGrid } from '@mui/x-data-grid';
import { Card, CardContent } from '@sunwisesoftware/sunwise-ui';
import { isEmpty, isEqual } from 'lodash';
import PropTypes from 'prop-types';

import { CustomPagination } from 'common/components';
import { TABLE_PAGE_SIZE_OPTIONS } from 'common/constants';

import ProductColumns from './ProductColumns';

const ListItems = ({
    companyId,
    filterData,
    handleClickUpdate,
    isFetching,
    items,
    paginationData,
    setFilterData,
}) => {
    const [rowCount, setRowCount] = useState(0);
    const [currentFilterData, setCurrentFilterData] = useState(filterData);

    const pageSizeOptions = TABLE_PAGE_SIZE_OPTIONS;

    const columns = ProductColumns();
    const getRowHeight = () => 'auto';
    const initialState = {
        pagination: { paginationModel: { pageSize: pageSizeOptions[0] } },
    };
    const onPaginationModelChange = (model) =>
        setFilterData((prev) => ({ ...prev, ...model }));
    const onRowClick = (params) => handleClickUpdate(companyId, params.row);
    const onSortModelChange = (model) => {
        if (!model[0]) return;
        setFilterData((prev) => ({
            ...prev,
            orderBy: model[0].field.toLocaleLowerCase(),
            sortBy: model[0].sort,
        }));
    };
    const paginationModel = {
        page: paginationData?.current_page - 1 || 0,
        pageSize: filterData?.pageSize || pageSizeOptions[0],
    };
    const slots = { pagination: CustomPagination };
    const slotProps = { pagination: { pageSizeOptions } };

    useEffect(() => {
        if (isEmpty(paginationData)) return;
        setRowCount((prev) =>
            paginationData?.total_rows !== undefined
                ? paginationData?.total_rows
                : prev,
        );
    }, [paginationData?.total_rows]);

    useEffect(() => {
        if (isEqual(currentFilterData, filterData)) return;
        setCurrentFilterData(filterData);
    }, [filterData]);

    return (
        <Card>
            <CardContent>
                <DataGrid
                    columns={columns}
                    disableColumnMenu
                    disableRowSelectionOnClick
                    editMode="row"
                    getRowHeight={getRowHeight}
                    initialState={initialState}
                    loading={isFetching}
                    onPaginationModelChange={onPaginationModelChange}
                    onRowClick={onRowClick}
                    onSortModelChange={onSortModelChange}
                    pageSizeOptions={pageSizeOptions}
                    pagination
                    paginationMode="server"
                    paginationModel={paginationModel}
                    rowCount={rowCount}
                    rows={items}
                    slotProps={slotProps}
                    slots={slots}
                    sortingMode="server"
                />
            </CardContent>
        </Card>
    );
};

ListItems.propTypes = {
    companyId: PropTypes.string,
    filterData: PropTypes.object,
    handleClickUpdate: PropTypes.func,
    isFetching: PropTypes.bool,
    items: PropTypes.array,
    paginationData: PropTypes.object,
    setFilterData: PropTypes.func,
};

export default ListItems;
